<i18n lang='yml' src='../i18n/ExamBookForm.yml'></i18n>
<template>
  <div>
		<div class="layout-tile inventory_item ">
      <div class="heading-block mb-0 d-flex">
        <h4 v-if="examData">
         {{ $t('header') }} {{examData.test_id}} - {{examData.version_name}} - {{ examData.name[locale] }}
         <span v-if="examData.inter_provincial_exam"> - {{ $t('inter_provincial')}} </span>
        </h4>
        
      </div>
      
      <div v-if="examData" class="header-block mb-3">
          <div class="post-meta">
            <ul class="list-inline list-annotation"> 
            <li class="list-inline-item">
              <span class="status-bold">
                {{`${$t('exam_type')}:`}}
              </span>
              {{examData.exam_type.name[locale]}}    
            </li>
            <li class="list-inline-item">
              <span class="status-bold">
                {{`${$t('current_inventory')}`}}
              </span>         
              {{current_count}}
            </li>
            <li class="list-inline-item">
              <span class="status-bold">
                {{`${$t('available_inventory')}`}}
              </span>
              {{available_count}}
              </li>
            </ul>
          </div>
        </div>
    </div>

    <flash :message_type="message_type" :message_text="message_text"/>
      <p class="border-bottom">
        {{$t('description')}}
      </p>
      <Form v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
          <div v-if="examData" class="form-group border-bottom mt-4">

            <div class="row">
              <div class="form-group col-sm-12 col-md-4">
                <label for="last_control_number_assigned"> {{$t('last_control_number_assigned')}} </label>
                <input id="last_control_number_assigned" disabled="true" type="text" class="form-control" :value="last_code">
              </div>
            </div>
            <div class="row border-top">
              <div class="form-group col-sm-12 col-md-4">
                <label for="starting_amount"> {{$t('starting_amount')}} </label>
                <input id="starting_amount" disabled="true"  type="number" class="form-control" :value="getStartingCount">
              </div>
              <div class="form-group col-sm-12 col-md-4">            
                <Field 
                  v-model.number="itemData.amount"
                  :name="$t('amount')" 
                  rules="greater_than_zero|less_than:1000|numeric|required"
                  v-slot="{ errors, field }">
                  <label :for="$t('amount')"> {{$t('amount')}} </label>
                  <input :id="$t('amount')"
                    class="form-control" 
                    :class="{'is-invalid': errors[0]}" 
                    v-bind="field"
                    type="number">
                  <div class="invalid-feedback" id="number-error" v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    <span> {{ errors[0] }} </span>
                  </div>
                </Field>   
              </div>
              <div class="form-group col-sm-12 col-md-4">     
                <label for="ending_amount"> {{$t('ending_amount')}} </label>
                <input id="ending_amount" disabled="true"  type="number" class="form-control" :value="getEndingCount">
              
              </div>
            </div>
          </div>
          <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
            <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>
         
          <div class="btn-row d-flex">
            <button type="submit" class="btn btn-primary btn-success no-shadow">
              <font-awesome-icon :icon="['fa', 'save']" />
              {{ $t('create') }}
            </button>
            <a class="btn btn-light ml-auto" :href="base_path">
              <font-awesome-icon :icon="['fa', 'times']" />
              {{ $t('cancel') }}
            </a>
          </div>
      </Form>
  </div>
</template>
<script>
import flash from '../../../../shared/flash_messages/components/Flash.vue'
import '../../../../../javascripts/application/vee-validate-rules.js'
import { sendAjaxRequest, ajaxResponseMessage } from '../../../../shared/typescripts/ajax.ts'
import { setErrorMessage } from '../../../../shared/typescripts/error.ts'

import { Form, Field } from 'vee-validate'
export default {
  props: ['locale', 'base_path', 'exam_data', 'last_code', 'count', 'current_count', 'available_count'],

  components: {
    flash,
    Form,
    Field
  },

  data() {
    return {
      loading: false,
      error: false,
      examData: null,
      lastBook: null,
      existingBookCount: null,
      itemData: {
        amount: 0,
        inventoryable_id: null,
        inventoryable_type: 'Exam',
        container_id: null,
        status: 'received'
      },
      message_text: [],
      message_type: "",
      showErrorBanner: false
    }
  },

  created() {
    this.$i18n.locale = this.locale;
  },

  mounted() {
    try{
      this.examData = JSON.parse(this.exam_data)
      this.existingBookCount = parseInt(this.count)
    }
    catch(err){
      this.error = true;
    }
  },
  computed: {
    getStartingCount(){
    return this.existingBookCount + 1
    },
    getEndingCount(){
      return this.itemData.amount <= 0 ? null : this.existingBookCount + this.itemData.amount
    }
  },

  methods: {
    setErrorMessage({ valuese, errors, results }) {
      setErrorMessage(this, errors, true)
    },

    submitUserInput(event) {
      let payload = []

      this.itemData.inventoryable_id = this.examData.id

      payload = { inventory_item: this.itemData }

      this.message_text = [];

      sendAjaxRequest('POST', this.base_path, 'json', payload, ajaxResponseMessage, this.throwError)

    },

    throwError() {
      console.log("Error")
    }
  }
}
</script>
